import {AxiosResponse} from "axios";
import {PageableModel} from "../../common/models/table";
import {LightBoardModel, LightBoardSendMessageModel, ManualOperatingSignCode} from "../models/lightBoard";
import {HttpErrorModel} from "../../common/models/httpError";
import http from "../../common/services/httpService";
import {Api, apiUrls} from "../../helpers/api";

export class LightBoardService {
    public static async getAll(): Promise<AxiosResponse<PageableModel<LightBoardModel>>> {
        return await http.get<PageableModel<LightBoardModel>>(Api.getUrl(apiUrls.lightboard.allLightBoards));
    }

    public static async switchToAutoMode(id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(apiUrls.lightboard.lightBoard)}/${id}/switch-to-auto`);
    }

    public static async getAllSings(): Promise<AxiosResponse<ManualOperatingSignCode[]>> {
        return await http.get<ManualOperatingSignCode[]>(Api.getUrl(apiUrls.lightboard.sings));
    }

    public static async sendMessageForLightBoard(id: string ,message: LightBoardSendMessageModel): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(apiUrls.lightboard.lightBoard)}/${id}/send-manual-message`, message);
    }
}
